import React from 'react';
import cx from 'classnames';
import YouTubePlayer from 'youtube-player';

import { initGA, logPageView } from '../layout/google.js';
import { initFB, logFBPageView } from '../layout/facebook.js';

import DropboxLogo from '../svgs/dropboxLogo.js';

class Hero extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showVideo: false,
      youtube: props.item.fields.youtubeUrlId,
    };
    this.player = React.createRef();
  }

  componentDidMount() {
    initGA();
    logPageView();
    initFB();
    logFBPageView();
    const player = this.player.current.querySelector('.js-video');
    if (player) {
      const theplayer = YouTubePlayer(player, {
        videoId: this.state.youtube,
      });
      this.setState({
        videoPlayer: theplayer,
      });
    }
  }

  playVideo() {
    if (this.props.item.fields.youtubeUrlId) {
      this.setState({
        showVideo: true,
      });
      this.state.videoPlayer.playVideo();
    }
  }

  render() {
    const { item, data } = this.props;
    return (
      <div
        key={item.sys.id}
        className={cx('rel hero', {
          video: item.fields.youtubeUrlId,
        })}
        ref={this.player}
        onClick={() => this.playVideo()}
      >
        <div className="abs z1 x y top left f ac jcc aic">
          <div>
            {item.fields.title && <h1 className="cw p1">{item.fields.title}</h1>}
            {item.fields.youtubeUrlId && <div className="hero__play" />}
          </div>
        </div>
        {item.fields.youtubeUrlId && (
          <div
            className={`hero__video abs top left x y ${
              this.state.showVideo ? 'visible' : ''
            }`}
          >
            <div className="js-video" />
          </div>
        )}
        <img
          src={`${item.fields.coverImage.fields.file.url}?fm=jpg&q=70&fl=progressive`}
          alt={item.fields.title}
        />
      </div>
    );
  }
}

export default Hero;
